
/*
 *  This file app-routing.module.ts is part of HROne Inbox. The intelectual property owned by Uneecops Workplace Solution PVT. LTD.
 *  CopyrightYear: 2022
 *  (C) 2015-2022. All Right reserved. Uneecops Workplace Solution PVT. LTD.
 *
 */

import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

const routes: Routes = [
  {
    path: 'client-feedback',
    loadChildren: () => import('./performance/policy360-client-feedback-approval/policy360-client-feedback-approval.module').then(m => m.Policy360ClientFeedbackApprovalModule)
  },
  {
    path: 'candidate-profile-completion',
    loadChildren: () => import('./recruitment/add-candidate/add-candidate.module').then(m => m.AddCandidateModule)
  },
  {
    path: 'candidate-document-completion',
    loadChildren: () => import('./recruitment/candidate-document/candidate-document.module').then(m => m.CandidateDocumentModule)
  },
  {
    path: 'candidate-offer',
    loadChildren: () => import('./recruitment/candidate-offer-letter/candidate-offer-letter.module').then(m => m.CandidateOfferLetterModule)
  },
  {
    path: 'career-portal',
    loadChildren: () => import('./recruitment/preview/preview.module').then(m => m.PreviewModule)
  },
  {
    path: 'apply-job',
    loadChildren: () => import('./recruitment/apply-job/apply-job.module').then(m => m.ApplyJobModule)
  },
  {
    path: 'snapshot-details',
    loadChildren: () => import('./workforce/snapshot/snapshot.module').then(m => m.SnapshotModule)
  },
  {
    path: 'personal-details',
    loadChildren: () => import('./workforce/personal/personal.module').then(m => m.PersonalModule)

  },
  {
    path: 'professional-details',
    loadChildren: () => import('./workforce/professional/professional.module').then(m => m.ProfessionalModule)
  },
  {
    path: 'family-details',
    loadChildren: () => import('./workforce/family/family.module').then(m => m.FamilyModule)
  },
  {
    path: 'health-insurance-details',
    loadChildren: () => import('./workforce/health-insurance/health-insurance.module').then(m => m.HealthInsuranceModule)
  },
  {
    path: 'other-details',
    loadChildren: () => import('./workforce/other-details/other-details.module').then(m => m.OtherDetailsModule)
  },
  {
    path: 'bank-details',
    loadChildren: () => import('./workforce/bank/bank.module').then(m => m.BankModule)
  },
  {
    path: 'previous-details',
    loadChildren: () => import('./workforce/previous-details/previous-details.module').then(m => m.PreviousDetailsModule)
  },
  {
    path: 'documents-details',
    loadChildren: () => import('./workforce/documnets/documnets.module').then(m => m.DocumnetsModule)
  },
  {
    path: 'verify-kyc', loadChildren: () => import('./recruitment/verify-kyc/verify-kyc.module').then(m => m.VerifyKycModule)
  },
  {
    path: 'digiAccept',
    loadChildren: () => import('./payroll/digital-acceptance/digital-acceptance.module').then(m => m.DigitalAcceptanceModule)
  },
  { path: 'profile-completion', loadComponent: () => import('.//workforce/profile-completion/profile-completion.component').then(m => m.ProfileCompletionComponent) },
  {
    path: 'candidate-offer-view',
    loadComponent: () => import('./recruitment/candidate-offer-view/candidate-offer-view.component').then(m => m.CandidateOfferViewComponent)
  },
  {
    path: 'payment-status/:orderId',
    loadComponent: () => import('./recruitment/payment-status/payment-status.component').then(m => m.PaymentStatusComponent)
  },
  {
    path: 'blob',
    children: [
      {
        path: 'access-denied',
        loadComponent: () => import('./global/components/blob/permission-denied/permission-denied.component').then(m => m.PermissionDeniedComponent)
      },
      {
        path: 'request-otp',
        loadComponent: () => import('./global/components/blob/blob-otp/blob-otp.component').then(m => m.BlobOtpComponent)
      },
      {
        path: 'verify-otp',
        loadComponent: () => import('./global/components/blob/blob-otp-verify/blob-otp-verify.component').then(m => m.BlobOtpVerifyComponent)
      },
      {
        path: 'download-complete',
        loadComponent: () => import('./global/components/blob/download-complete/download-complete.component').then(m => m.DownloadCompleteComponent)
      },
    ]
  },
  { path: '**', loadChildren: () => import('./not-found/not-found.module').then(m => m.NotFoundModule) },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {})],
  exports: [RouterModule]
})
export class AppRoutingModule { }